module.exports = __webpack_public_path__ + "static/media/liveroom_defult_banner1.3e6a748e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom_defult_banner1.png
// module id = 2023
// module chunks = 6